export const hospitalEncounterMasterColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'encounter__account_number',
  'encounter__admit_date',
  'encounter__admit_location',
  'encounter__admit_source_code',
  'encounter__admit_source_name',
  'encounter__admit_type_code',
  'encounter__admit_type_name',
  'encounter__charity_care_flag',
  'encounter__charity_care_level',
  'encounter__code_complete_date',
  'encounter__discharge_date',
  'encounter__ecd_number',
  'encounter__enterprise_medical_record_number',
  'encounter__first_patient_statement_date',
  'encounter__from_date',
  'encounter__hospital_service_type',
  'encounter__hospital_service_type_description',
  'encounter__initial_inpatient_visit_date',
  'encounter__medical_record_number',
  'encounter__patient_class',
  'encounter__patient_class_name',
  'encounter__patient_control_number',
  'encounter__patient_id',
  'encounter__patient_type_code',
  'encounter__patient_type_name',
  'encounter__return_from_agency_amount',
  'encounter__return_from_agency_date',
  'encounter__transfer_to_agency_amount',
  'financial_summary__account_status',
  'financial_summary__additional_payer_payments',
  'financial_summary__amount_transferred_to_collection',
  'financial_summary__bad_debt_balance',
  'financial_summary__bad_debt_eligible_flag',
  'financial_summary__bad_debt_flag',
  'financial_summary__balance_subtotal01',
  'financial_summary__balance_subtotal02',
  'financial_summary__balance_subtotal03',
  'financial_summary__balance_subtotal04',
  'financial_summary__billing_indicator',
  'financial_summary__collector_code',
  'financial_summary__current_agency_code',
  'financial_summary__current_financial_class',
  'financial_summary__current_payer_plan_code',
  'financial_summary__encounter_unbilled_amount',
  'financial_summary__expected_reimbursement',
  'financial_summary__first_billed_date',
  'financial_summary__guest_pay_eligible_flag',
  'financial_summary__insurance_verification_hold_flags',
  'financial_summary__interest_refund_flag',
  'financial_summary__interest_zero_flag',
  'financial_summary__is_full_self_pay',
  'financial_summary__is_guarantor_eligible',
  'financial_summary__is_visit_eligible',
  'financial_summary__last_insurance_payment_date',
  'financial_summary__last_patient_statement_date',
  'financial_summary__manual_bill_hold_flag',
  'financial_summary__medical_records_coding_hold_flags',
  'financial_summary__medicare_payments',
  'financial_summary__most_recent_bill_date',
  'financial_summary__most_recent_bill_status',
  'financial_summary__on_pre_payment_plan_flag',
  'financial_summary__original_financial_class',
  'financial_summary__other_payments',
  'financial_summary__patient_billing_hold_flag',
  'financial_summary__patient_statement_cycle_code',
  'financial_summary__payment_group',
  'financial_summary__payment_plan_indicator',
  'financial_summary__payment_plan_installment_amount',
  'financial_summary__payment_plan_installment_date',
  'financial_summary__payment_priority_rank',
  'financial_summary__received_financial_care_flag',
  'financial_summary__total_account_balance',
  'financial_summary__total_adjustments',
  'financial_summary__total_charges',
  'financial_summary__total_insurance_adjustments',
  'financial_summary__total_insurance_balance',
  'financial_summary__total_insurance_payments',
  'financial_summary__total_insurance_refunds',
  'financial_summary__total_insurance_takeback',
  'financial_summary__total_patient_balance',
  'financial_summary__total_patient_other_adjustments',
  'financial_summary__total_patient_payments',
  'financial_summary__total_patient_refund',
  'financial_summary__total_payments',
  'financial_summary__trigger_presumptive_charity_scoring_evaluation_flag',
  'financial_summary__visit_statement_unique_identifier',
  'financial_summary__zero_balance_date',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'snapshot_id',
  'user_defined__user_defined_field1',
  'user_defined__user_defined_field10',
  'user_defined__user_defined_field2',
  'user_defined__user_defined_field3',
  'user_defined__user_defined_field4',
  'user_defined__user_defined_field5',
  'user_defined__user_defined_field6',
  'user_defined__user_defined_field7',
  'user_defined__user_defined_field8',
  'user_defined__user_defined_field9',
];
